"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceCatalogAvailableItemsFactory = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var CatalogConverter_1 = require("../../../convertors/fromBackend/CatalogConverter");
var InsightConverter_1 = require("../../../convertors/toBackend/InsightConverter");
var catalogWithAvailableItems_1 = require("./catalogWithAvailableItems");
var api_1 = require("../../../utils/api");
var ts_invariant_1 = require("ts-invariant");
var catalogItemUri = function (catalogItem) {
    if (sdk_model_1.isCatalogAttribute(catalogItem)) {
        return catalogItem.attribute.uri;
    }
    else if (sdk_model_1.isCatalogMeasure(catalogItem)) {
        return catalogItem.measure.uri;
    }
    else if (sdk_model_1.isCatalogFact(catalogItem)) {
        return catalogItem.fact.uri;
    }
    return catalogItem.dataSet.uri;
};
var BearWorkspaceCatalogAvailableItemsFactory = /** @class */ (function () {
    function BearWorkspaceCatalogAvailableItemsFactory(authCall, workspace, groups, items, options, mappings) {
        var _this = this;
        if (options === void 0) { options = {
            types: ["attribute", "measure", "fact", "dateDataset"],
            excludeTags: [],
            includeTags: [],
            loadGroups: true,
        }; }
        this.authCall = authCall;
        this.workspace = workspace;
        this.groups = groups;
        this.items = items;
        this.options = options;
        this.mappings = mappings;
        this.loadAvailableCatalogItems = function (sanitizedVisualizationObject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var types, compatibleBearItemTypes, bearTypes, itemDescriptions, availableItemUris;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        types = this.options.types;
                        compatibleBearItemTypes = types.filter(CatalogConverter_1.isCompatibleCatalogItemType);
                        if (compatibleBearItemTypes.length === 0) {
                            return [2 /*return*/, []];
                        }
                        bearTypes = compatibleBearItemTypes.map(CatalogConverter_1.convertItemType);
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.catalogue.loadItemDescriptionObjects(_this.workspace, sanitizedVisualizationObject.content, _this.mappings.attributeByDisplayFormUri);
                            })];
                    case 1:
                        itemDescriptions = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.catalogue.loadAvailableItemUris(_this.workspace, {
                                    catalogQueryRequest: {
                                        bucketItems: itemDescriptions,
                                        types: bearTypes,
                                    },
                                });
                            })];
                    case 2:
                        availableItemUris = _a.sent();
                        return [2 /*return*/, this.items.filter(function (item) { return availableItemUris.includes(catalogItemUri(item)); })];
                }
            });
        }); };
        this.loadAvailableDateDatasets = function (sanitizedVisualizationObject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, types, includeTags, excludeTags, dataset, production, includeDateGranularities, includeDateDatasets, _b, includeTagsIds, excludeTagsIds, dataSetIdentifier, shouldReturnAllDateDataSets, result;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.options, types = _a.types, includeTags = _a.includeTags, excludeTags = _a.excludeTags, dataset = _a.dataset, production = _a.production, includeDateGranularities = _a.includeDateGranularities;
                        includeDateDatasets = types.includes("dateDataset");
                        if (!includeDateDatasets) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, Promise.all([
                                api_1.objRefsToIdentifiers(includeTags, this.authCall),
                                api_1.objRefsToIdentifiers(excludeTags, this.authCall),
                                dataset ? api_1.objRefToIdentifier(dataset, this.authCall) : Promise.resolve(""),
                            ])];
                    case 1:
                        _b = _c.sent(), includeTagsIds = _b[0], excludeTagsIds = _b[1], dataSetIdentifier = _b[2];
                        shouldReturnAllDateDataSets = !production && !dataSetIdentifier;
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.catalogue.loadDateDataSets(_this.workspace, {
                                    bucketItems: sanitizedVisualizationObject.content,
                                    includeAvailableDateAttributes: true,
                                    dataSetIdentifier: dataSetIdentifier,
                                    attributesMap: _this.mappings.attributeByDisplayFormUri,
                                    includeObjectsWithTags: includeTagsIds.length ? includeTagsIds : undefined,
                                    excludeObjectsWithTags: excludeTagsIds.length ? excludeTagsIds : undefined,
                                    returnAllDateDataSets: shouldReturnAllDateDataSets,
                                    includeDateGranularities: includeDateGranularities,
                                });
                            })];
                    case 2:
                        result = _c.sent();
                        return [2 /*return*/, result.dateDataSets.map(function (dateDataSet) {
                                return CatalogConverter_1.convertDateDataset(dateDataSet, _this.mappings.attributeById);
                            })];
                }
            });
        }); };
    }
    BearWorkspaceCatalogAvailableItemsFactory.prototype.withOptions = function (options) {
        var newOptions = tslib_1.__assign(tslib_1.__assign({}, this.options), options);
        return new BearWorkspaceCatalogAvailableItemsFactory(this.authCall, this.workspace, this.groups, this.items, newOptions, this.mappings);
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.forDataset = function (dataset) {
        return this.withOptions({ dataset: dataset });
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.forTypes = function (types) {
        return this.withOptions({ types: types });
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.includeTags = function (tags) {
        return this.withOptions({ includeTags: tags });
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.excludeTags = function (tags) {
        return this.withOptions({ excludeTags: tags });
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.forItems = function (items) {
        return this.withOptions({ items: items });
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.forInsight = function (insight) {
        return this.withOptions({ insight: insight });
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.withGroups = function (loadGroups) {
        return this.withOptions({ loadGroups: loadGroups });
    };
    BearWorkspaceCatalogAvailableItemsFactory.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tempVisualizationObj, _a, availableCatalogItems, availableDateDatasets, allAvailableCatalogItems;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tempVisualizationObj = createVisObjectForAvailability(this.options, this.mappings);
                        return [4 /*yield*/, Promise.all([
                                this.loadAvailableCatalogItems(tempVisualizationObj),
                                this.loadAvailableDateDatasets(tempVisualizationObj),
                            ])];
                    case 1:
                        _a = _b.sent(), availableCatalogItems = _a[0], availableDateDatasets = _a[1];
                        allAvailableCatalogItems = tslib_1.__spreadArrays(availableCatalogItems, availableDateDatasets);
                        return [2 /*return*/, new catalogWithAvailableItems_1.BearWorkspaceCatalogWithAvailableItems(this.groups, this.items, allAvailableCatalogItems, this.options)];
                }
            });
        });
    };
    return BearWorkspaceCatalogAvailableItemsFactory;
}());
exports.BearWorkspaceCatalogAvailableItemsFactory = BearWorkspaceCatalogAvailableItemsFactory;
/**
 * Creates temporary visualization object, whose bucket items can then be used to construct the bucket items
 * used by the catalog resource. The construction of bucket items happens using some serious mojo in bear's api
 * client and requires these types of objects.
 *
 * This function will take all the items, strip arithmetic measures and measures derived from them,
 * transform all identifiers to URIs.
 */
function createVisObjectForAvailability(options, mappings) {
    var _a = options.items, items = _a === void 0 ? [] : _a, insight = options.insight;
    if (items.length === 0 && !insight) {
        throw new Error("No items or insight was specified.");
    }
    var itemsToUse = insight ? sdk_model_1.insightItems(insight) : items;
    var validItems = filterItemsForAvailabilityQuery(itemsToUse);
    var itemsWithUris = validItems.map(function (item) { return translateIdentifiersToUris(item, mappings); });
    var tempInsight = {
        insight: {
            title: "",
            filters: [],
            properties: {},
            sorts: [],
            visualizationUrl: "",
            buckets: [
                {
                    items: itemsWithUris,
                },
            ],
        },
    };
    return InsightConverter_1.convertInsightDefinition(tempInsight);
}
/*
 * Availability query must not contain arithmetic measures and measures derived from them.
 */
function filterItemsForAvailabilityQuery(items) {
    var arithmeticMeasuresIds = new Set();
    var otherMeasureIds = new Set();
    items.forEach(function (measure) {
        if (sdk_model_1.isArithmeticMeasure(measure)) {
            arithmeticMeasuresIds.add(sdk_model_1.measureLocalId(measure));
        }
        else if (sdk_model_1.isMeasure(measure)) {
            otherMeasureIds.add(sdk_model_1.measureLocalId(measure));
        }
    });
    return items.filter(function (item) {
        if (sdk_model_1.isAttribute(item) || sdk_model_1.isSimpleMeasure(item)) {
            return true;
        }
        else if (sdk_model_1.isArithmeticMeasure(item)) {
            return false;
        }
        else if (sdk_model_1.isPoPMeasure(item) || sdk_model_1.isPreviousPeriodMeasure(item)) {
            var masterMeasure = sdk_model_1.measureMasterIdentifier(item);
            // remove derived measures which are either derived from arithmetic measure or which do
            // not have their master among the items to query
            return !arithmeticMeasuresIds.has(masterMeasure) && otherMeasureIds.has(masterMeasure);
        }
        throw new ts_invariant_1.InvariantError("unexpected type of item encountered while constructing items for availability query");
    });
}
function translateIdentifiersToUris(item, mappings) {
    var _a, _b;
    if (sdk_model_1.isAttribute(item)) {
        var ref = sdk_model_1.attributeDisplayFormRef(item);
        if (sdk_model_1.isIdentifierRef(ref)) {
            var displayForm_1 = mappings.displayFormById[ref.identifier];
            return sdk_model_1.modifyAttribute(item, function (m) {
                return m.displayForm(sdk_model_1.uriRef(displayForm_1.meta.uri)).localId(sdk_model_1.attributeLocalId(item));
            });
        }
        return item;
    }
    else if (sdk_model_1.isSimpleMeasure(item)) {
        var ref = sdk_model_1.measureItem(item);
        if (sdk_model_1.isIdentifierRef(ref)) {
            var metric = mappings.measureById[ref.identifier];
            var fact = mappings.factById[ref.identifier];
            var uri_1 = (_a = metric === null || metric === void 0 ? void 0 : metric.uri) !== null && _a !== void 0 ? _a : fact.uri;
            return sdk_model_1.modifySimpleMeasure(item, function (m) { return m.measureItem(sdk_model_1.uriRef(uri_1)).localId(sdk_model_1.measureLocalId(item)); });
        }
        return item;
    }
    else if (sdk_model_1.isPoPMeasure(item)) {
        var ref = sdk_model_1.measurePopAttribute(item);
        if (sdk_model_1.isIdentifierRef(ref)) {
            var attribute = mappings.attributeById[ref.identifier];
            var dateAttribute = mappings.dateAttributeById[ref.identifier];
            var uri_2 = (_b = attribute === null || attribute === void 0 ? void 0 : attribute.attribute.meta.uri) !== null && _b !== void 0 ? _b : dateAttribute.attribute.uri;
            return sdk_model_1.modifyPopMeasure(item, function (m) { return m.popAttribute(sdk_model_1.uriRef(uri_2)).localId(sdk_model_1.measureLocalId(item)); });
        }
    }
    return item;
}
//# sourceMappingURL=availableItemsFactory.js.map